import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import MlmusertypeDashboard from '../MlmusertypeDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function MlmusertypePage() {
    const dispatch = useDispatch();
    const { MlmusertypeList} = useSelector((state)=>state.dmpaslice)
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < MlmusertypeDashboard />
    )

}